<!-- <div *hasScope="SCOPES.PARTIALLY_DELIVERED_REASONS.READ_ALL"> -->

<div class="flex flex-col gap-4">
  <!-- Filters -->
  <div class="rounded-2xl bg-white p-6 filters-shadow">
    <div class="mb-5 w-[320px]">
      <app-filter-item-search [label]="searchLabel" [placeholder]="searchPlaceholder" [(searchTerm)]="search" />
    </div>

    <div class="mb-6 grid grid-cols-4 gap-6">
      <!-- Created From -->
      <div>
        <app-filter-date-component [label]="createdFromLabel" [(value)]="createdFrom" />

        @if (createdFromError()) {
          <p class="mt-1 text-sm text-red-500">
            {{ createdFromError() }}
          </p>
        }
      </div>

      <!-- Created To -->
      <div>
        <app-filter-date-component [label]="createdToLabel" [(value)]="createdTo" />

        @if (createdToError()) {
          <p class="mt-1 text-sm text-red-500">
            {{ createdToError() }}
          </p>
        }
      </div>

      <!-- Modified From -->
      <div>
        <app-filter-date-component [label]="modifiedFromLabel" [(value)]="modifiedFrom" />

        @if (modifiedFromError()) {
          <p class="mt-1 text-sm text-red-500">
            {{ modifiedFromError() }}
          </p>
        }
      </div>

      <!-- Modified To -->
      <div>
        <app-filter-date-component [label]="modifiedToLabel" [(value)]="modifiedTo" />

        @if (modifiedToError()) {
          <p class="mt-1 text-sm text-red-500">
            {{ modifiedToError() }}
          </p>
        }
      </div>
    </div>

    <hr class="mb-5 border-gray-200" />

    <div class="flex items-center justify-between">
      <app-filter-sorting-component
        [(orderBy)]="orderBy"
        [orderDir]="orderDir()"
        [sortOptions]="sortOptions"
        (toggleOrder)="toggleSortOrder()" />

      <div class="flex gap-3">
        <app-submit-button type="secondary" (click)="resetFilters()">
          <span i18n="@@partiallyDeliveredReasonsReset">Clear</span>
        </app-submit-button>

        <app-submit-button type="primary" (click)="applyFilters()">
          <span i18n="@@partiallyDeliveredReasonsApply">Apply</span>
        </app-submit-button>
      </div>
    </div>
  </div>

  <!-- Table -->

  <div class="rounded-2xl bg-white p-6 shadow-md">
    @if (loading()) {
      <div class="flex min-h-[300px] items-center justify-center">
        <app-loading />
      </div>
    } @else if (errorMessage()) {
      <app-error-data [title]="errorMessage()!" />
    } @else {
      <app-tables
        [headerItems]="headerItems()"
        [rows]="pagedRows()"
        [currentActions]="actions"
        [isFiltersApplied]="isFiltersApplied()"
        [emptyFilterTitle]="isArabic() ? 'لا توجد أسباب تطابق معايير البحث.' : 'No reasons match your criteria.'"
        [emptyContentTitle]="isArabic() ? 'لا توجد أسباب تسليم جزئي' : 'No Partially Delivered Reasons Found'"
        [emptyContentDescription]="
          isArabic() ? 'لا توجد أسباب تسليم جزئي في النظام.' : 'No partially delivered reasons found in the system.'
        "
        (actionTrigger)="handleAction($event)" />

      @if (tableRows().length > 0) {
        <app-pagination
          [itemsPerPage]="itemsPerPage()"
          [currentPage]="currentPage()"
          [getPageNumbers]="getPageNumbers()"
          [totalPages]="totalPages()"
          [startItem]="startItem()"
          [endItem]="endItem()"
          [totalItems]="totalItemsFromApi()"
          (previousPage)="onPreviousPage()"
          (nextPage)="onNextPage()"
          (goToPage)="onGoToPage($event)"
          (changePageNumber)="onChangePageNumber($event)"
          (pageSizeChange)="onPageSizeChange()" />
      }
      <!-- @else {

      <div
        class="flex flex-col items-center justify-center py-12 text-center">

        @if (search()) {

          <h3 class="text-lg font-semibold text-gray-700">
            <span i18n="@@partiallyDeliveredReasonsNoSearchResults">
              No reasons match your search.
            </span>
          </h3>

        }
        @else if (
          createdFrom() ||
          createdTo() ||
          modifiedFrom() ||
          modifiedTo()
        ) {

          <h3 class="text-lg font-semibold text-gray-700">
            <span i18n="@@partiallyDeliveredReasonsNoFilterResults">
              No reasons match your selected filters.
            </span>
          </h3>

        } @else {

          <h3 class="text-lg font-semibold text-gray-700">
            <span i18n="@@partiallyDeliveredReasonsNoReasons">
              No partially delivered reasons found.
            </span>
          </h3>

        }

      </div>

    } -->
    }
  </div>
  <div *hasScope="SCOPES.PARTIALLY_DELIVERED_REASONS.DELETE">
    @if (showDeleteDialog()) {
      <app-confirmation-dialog
        [layout]="'start'"
        [title]="deleteTitle"
        [description]="locale.startsWith('ar') ? deleteDescriptionAr : deleteDescriptionEn"
        [confirmContent]="deleteButton"
        [cancelContent]="cancelButton"
        [error]="deleteError()"
        (onSubmit)="confirmDelete()"
        (onCancel)="closeDeleteConfirmation()"></app-confirmation-dialog>
    }
  </div>
</div>

<!-- </div> -->
